import { UI_PROXY_CONTEXT } from "../../utils/constants";
import { grafanaUrl } from "../../utils/urls";

// One entry per embedded tool. Adding a new one = an entry here, a key in
// UI_PROXY_CONTEXT and a <Route> in App.js.
export const UI_PROXY_CONFIG = {
  [UI_PROXY_CONTEXT.logs]: {
    title: "Logs",
    subtitle: "Grafana logs explorer",
    appName: "Grafana",
    url: grafanaUrl,
    frameTitle: "Grafana logs",
    openLabel: "OPEN IN GRAFANA",
    // Allow /logs?path=/explore style deep links (same-origin paths only).
    allowPath: true,
  },
};

export const FRAME_LOAD_TIMEOUT_MS = 15000;
export const EXPANDED_CACHE_KEY = "uiProxyExpanded";
